import React from 'react';
import { NavLink } from 'react-router-dom';

interface Props {
  to: string;
  style:
    | React.CSSProperties
    | ((props: { isActive: boolean; isPending: boolean }) => React.CSSProperties | undefined);
  children: React.ReactNode;
}

const CustomLink = ({ to, style, children }: Props) => {
  return (
    <NavLink to={to} style={style}>
      {children}
    </NavLink>
  );
};

export default CustomLink;
